import { render, staticRenderFns } from "./Slide.vue?vue&type=template&id=4900a212&scoped=true&lang=pug"
import script from "./Slide.vue?vue&type=script&lang=js"
export * from "./Slide.vue?vue&type=script&lang=js"
import style0 from "./Slide.vue?vue&type=style&index=0&id=4900a212&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4900a212",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4900a212')) {
      api.createRecord('4900a212', component.options)
    } else {
      api.reload('4900a212', component.options)
    }
    module.hot.accept("./Slide.vue?vue&type=template&id=4900a212&scoped=true&lang=pug", function () {
      api.rerender('4900a212', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/Slide.vue"
export default component.exports